import Super from './class.js';
let serverList={
	get:{
		stationMail: '/open/wtf-adv/list'
	},
	post:{}
};
export default new Super(serverList,'pushserv');